/**
 * @generated SignedSource<<467d9005a09f003111fc375d18e2ec97>>
 * @relayHash a99f1bb480a0c3cd903df82079f26a67
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8b33bb91d8fba2bc3c62f53047f514c0277f7d4ffc5f126c563d08850b4b7242

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { AsyncMenuWithQueryQuery } from './AsyncMenuWithQueryQuery.graphql';

const node: PreloadableConcreteRequest<AsyncMenuWithQueryQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "8b33bb91d8fba2bc3c62f53047f514c0277f7d4ffc5f126c563d08850b4b7242",
    "metadata": {},
    "name": "AsyncMenuWithQueryQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
